export default __webpack_public_path__ + "static/media/FIGHT OR DIE 1.23b302a1.png";